export const LINKS = {
  DMCA_POLICY: 'https://www.promeet.live/dmca-policy',
  PRIVACY_POLICY: 'https://www.promeet.live/privacy-policy',
  SUPPORT: 'https://www.promeet.live/learn/',
  TERMS_OF_SERVICE: 'https://www.promeet.live/terms-of-service',
}

export const PROMEET_HANDLE = '@promeet'
